import { render, staticRenderFns } from "./Shops.vue?vue&type=template&id=5c62ca69&scoped=true&"
import script from "./Shops.vue?vue&type=script&lang=js&"
export * from "./Shops.vue?vue&type=script&lang=js&"
import style0 from "./Shops.vue?vue&type=style&index=0&id=5c62ca69&lang=less&scoped=true&"
import style1 from "./Shops.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c62ca69",
  null
  
)

export default component.exports